import { Suspense, lazy, useState } from 'react';
import { useNavigate } from 'react-router';
import { Icon } from '../../components/Icon';
import { closeSheet } from '../../state/sheets';
import { useEntities } from '../shared/useMap';
import { EntityOptions } from './EntityOptions';
import { useMapState } from './mapState';
import { useUI } from '../../state/ui';

const EntityPicker = lazy(() => import('./EntityPicker').then(m => ({ default: m.EntityPicker })));

/** Campo de entidades (tarefa e rotina): chips, adicionar pela lista ou selecionando no mapa. */
export function EntityField({ value, onChange, editable }: { value: string[]; onChange: (ids: string[]) => void; editable: boolean }) {
  const ents = useEntities();
  const [picking, setPicking] = useState(false);
  const openInMap = useOpenInMap();
  if (!ents.graph) return <><span className="muted">Mapa societário indisponível.</span> <button type="button" className="side-link inline" onClick={() => { closeSheet(); openInMap(null); }}>Abrir o mapa</button></>;
  return (
    <>
      <div className="ent-chips">
        {value.length ? value.map(id => (
          <span key={id} className={`ent-chip ${ents.exists(id) ? '' : 'fora'}`}>
            <button type="button" className="ent-ir" title="Ver no mapa" onClick={() => { closeSheet(); openInMap(id); }}>{ents.name(id)}</button>
            {editable && <button type="button" aria-label={`Remover ${ents.name(id)}`} onClick={() => onChange(value.filter(x => x !== id))}><Icon name="x" /></button>}
          </span>
        )) : <span className="muted">Nenhuma entidade ligada.</span>}
      </div>
      {editable && (
        <div className="ent-actions">
          <select className="ent-add" aria-label="Adicionar entidade" value="" onChange={e => { const v = e.target.value; if (v && !value.includes(v)) onChange([...value, v]); }}>
            <EntityOptions empty={['', 'Adicionar entidade…']} />
          </select>
          <button type="button" className="btn small-btn" onClick={() => setPicking(true)}><Icon name="mapa" /> Selecionar no mapa</button>
        </div>
      )}
      {picking && <Suspense fallback={null}><EntityPicker initial={value} onClose={() => setPicking(false)} onConfirm={ids => { onChange(ids); setPicking(false); }} /></Suspense>}
    </>
  );
}

/** Abre o mapa (opcionalmente já centrado numa entidade). */
export function useOpenInMap() {
  const nav = useNavigate();
  return (id: string | null) => {
    useUI.getState().setMap({ tab: 'mapa' });
    if (id) useMapState.getState().set({ goTo: id, selected: id });
    nav('/mapa');
  };
}
